import { RemitService } from '@dav-core/services/remit.service';
import { ContractType } from '@dav-model/api/response/pending-contract.response.model';
import { ContractFilterGroupType, ContractFilterType } from '@dav-model/remit-filter.model';

import * as RemitActions from './remit.actions';

export interface State {
  pendingContracts: ContractType[];
  pendingGridContracts: ContractType[];
  pendingToRemitContracts: ContractType[];
  pendingToDeclineContracts: ContractType[];
  pendingFilters: ContractFilterType[];
  submittedPendingContracts: ContractType[];
  loadingPendingContracts: boolean;

  remittedContracts: ContractType[];
  remittedGridContracts: ContractType[];
  remittedFilters: ContractFilterGroupType[];
}

const InitialState: State = {
  pendingContracts: [],
  pendingGridContracts: [],
  pendingToRemitContracts: [],
  pendingToDeclineContracts: [],
  pendingFilters: [],
  submittedPendingContracts: [],
  loadingPendingContracts: false,

  remittedContracts: [],
  remittedGridContracts: [],
  remittedFilters: []
};

export function reducer(state = InitialState, action: RemitActions.All): State {

  switch (action.type) {

    case RemitActions.GET_PENDING_CONTRACTS: {
      return {
        ...state,
        loadingPendingContracts: true
      };
    }

    case RemitActions.GET_PENDING_CONTRACTS_SUCCESS: {
      return {
        ...state,
        pendingContracts: action.payload.contracts.pendingContracts,
        pendingGridContracts: action.payload.contracts.pendingContracts,
        pendingToRemitContracts: action.payload.contracts.pendingToRemitContracts,
        pendingToDeclineContracts: action.payload.contracts.pendingToDeclineContracts,
        pendingFilters: action.payload.filters,
        loadingPendingContracts: false
      };
    }

    case RemitActions.FILTER_PENDING_GRID: {
      const contracts = RemitService.filterPendingGrid(action.payload, state.pendingContracts);

      return {
        ...state,
        pendingGridContracts: contracts
      };
    }

    case RemitActions.ADD_TO_PENDING_REMIT: {
      return {
        ...state,
        pendingGridContracts: state.pendingGridContracts.map(item => {
          if (item.econContractId === action.payload.econContractId) {
            item.addToRemit = true;

            return item;
          } else {
            return item;
          }
        }),
        pendingToRemitContracts: [...state.pendingToRemitContracts, action.payload]
      };
    }

    case RemitActions.DELETE_FROM_PENDING_REMIT: {
      return {
        ...state,
        pendingGridContracts: state.pendingGridContracts.map(item => {
          if (item.econContractId === action.payload) {
            item.addToRemit = false;

            return item;
          } else {
            return item;
          }
        }),
        pendingToRemitContracts: state.pendingToRemitContracts.filter(item =>
          item.econContractId !== action.payload)
      };
    }

    case RemitActions.DECLINE_PENDING_CONTRACT: {

      const contracts = RemitService.declineAndUpdateContracts(state.pendingGridContracts, action.payload);

      return {
        ...state,
        pendingGridContracts: contracts,
        pendingToDeclineContracts: [...state.pendingToDeclineContracts, action.payload]
      };
    }

    case RemitActions.REINSTATE_PENDING_CONTRACT: {

      const contracts = RemitService.reinstateAndUpdateContracts(state.pendingGridContracts, action.payload);

      return {
        ...state,
        pendingGridContracts: contracts,
        pendingToDeclineContracts: state.pendingToDeclineContracts.filter(item =>
          item.econContractId !== action.payload.econContractId),
        pendingToRemitContracts: contracts.filter(item =>
          item.addToRemit === true)
      };
    }

    case RemitActions.ADD_ALL_TO_PENDING_REMIT: {
      const addedContracts = action.payload.map(item => {
        if (!item.dupError && !item.decline && !item.addToRemit) {
          item.addToRemit = true;
          item.decline = false;

          return item;
        } else {
          return item;
        }

      });

      return {
        ...state,
        pendingToRemitContracts: addedContracts.filter(item => item.addToRemit)
      };
    }

    case RemitActions.REMOVE_ALL_FROM_PENDING_REMIT_ONLY: {
      return {
        ...state,
        pendingGridContracts: state.pendingGridContracts.map(item => {

          if (item.addToRemit === true) {
            item.addToRemit = false;
          }

          return item;
        }),
        pendingToRemitContracts: []
      };
    }

    case RemitActions.REMOVE_ALL_FROM_DECLINED_REMIT_ONLY: {
      const contracts = state.pendingGridContracts.reduce((prevValue, elem) => RemitService.reinstateAndUpdateContracts(prevValue, elem), state.pendingGridContracts);

      return {
        ...state,
        pendingGridContracts: contracts,
        pendingToDeclineContracts: [],
        pendingToRemitContracts: contracts.filter(elem => {
          return elem.addToRemit;
        })
      };
    }

    case RemitActions.SUBMIT_ALL_PENDING_REMIT_SUCCESS: {
      return {
        ...state,
        pendingContracts: action.payload.contracts.pendingContracts,
        pendingGridContracts: action.payload.contracts.pendingContracts,
        pendingToRemitContracts: action.payload.contracts.pendingToRemitContracts,
        pendingToDeclineContracts: action.payload.contracts.pendingToDeclineContracts,
        pendingFilters: action.payload.filters,
        // copies over submitted request for printing
        submittedPendingContracts: action.payload.submittedRemittedRequest
      };
    }

    case RemitActions.GET_REMITTED_CONTRACTS_SUCCESS: {
      return {
        ...state,
        remittedContracts: action.payload.contracts.remittedContracts,
        remittedGridContracts: [],
        remittedFilters: action.payload.filters
      };
    }

    case RemitActions.FILTER_REMITTED_GRID: {
      const contracts = RemitService.filterRemittedGrid(action.payload, state.remittedContracts);

      return {
        ...state,
        remittedGridContracts: contracts
      };
    }

    default: {
      return state;
    }
  }
}
